import React, { Suspense, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import enTranslations from "@shopify/polaris/locales/en.json";
import { AppProvider, Spinner } from "@shopify/polaris";
import "./index.scss";
import { Provider, useDispatch, useSelector } from "react-redux";

import {
  RouterProvider,
  Outlet,
  createBrowserRouter,
  Navigate,
  useLocation,
  RouteProps,
  Route,
  Routes,
} from "react-router-dom";
import App from "./App";

import SellerDashboard from "./sellers_module/pages/sellerPages/seller_dashboard/seller_dashboard";
import store from "./sellers_module/store/store";
import AppStoreHeader from "./sellers_module/layout/AppStoreHeader";
import AppInfo from "./sellers_module/pages/sellerPages/app_details/app_details";
import DevHome from "./developers_module/dev_pages/dev_home/dev_home";
import DeveloperLogin from "./developers_module/dev_pages/auth/developer_login";
import DeveloperSignup from "./developers_module/dev_pages/auth/developer_signup";
import developerStore from "./developers_module/dev_store/store";
import Subscription from "./sellers_module/pages/sellerPages/subscription/subscription";

import DevAppPage from "./developers_module/dev_pages/dev_app_page/dev_app_page";

import DevSettings from "./developers_module/dev_pages/dev_settings/dev_settings";
import { Box } from "@mui/material";
import DevCreateApps from "./developers_module/dev_pages/dev_create_apps/dev_create_apps";
import DevHeader from "./developers_module/dev_layout/devHeader";

import ReactGA from "react-ga4";
import AppsSidebar from "./developers_module/dev_components/sidenav/apps_sidenav/apps_sidebar";
import Sidebar from "./developers_module/dev_components/sidenav/sidenav";
import { devIsSidenavdefault } from "./developers_module/dev_store/slice/side_navbar";
import AppsOverView from "./developers_module/dev_pages/apps_overview/apps_overview";
import AppOverView from "./developers_module/dev_pages/apps_overview/apps_overview";
import TechConfiguration from "./developers_module/dev_pages/apps_configuration/tech_configurations/app_configurations";
import ManageConfigurations from "./developers_module/dev_pages/apps_configuration/app_listing/app_listing";
import DevPermissionnew from "./developers_module/dev_pages/dev_permissions/dev_permission_new";

import DevPlan from "./developers_module/dev_pages/dev_plans/dev_plan";
import RequestPermission from "./developers_module/dev_pages/dev_permissions/request_permission";
import NotFoundPage from "./sellers_module/components/not_found/not_found_page";
import Shiprocket_Audience from "./audience_module/shiprocket_audience";
import ProductPage from "./audience_module/product_list/productpage/product_page";
import AudienceDashboard from "./audience_module/audience_dashboard/dashboard";


export const AppLayout = () => {
  const location = useLocation();

  //check update side navbar form developer module
  const [isSidenav, setAppIsSidenav] = useState(false);
  const [isTabletView, setIsTabletView] = useState<boolean>(false);
  const [isMobileView, setIsMobileView] = useState<boolean>(false);


  useEffect(() => {
    const checkScreenSize = () => {
      setIsTabletView(window.innerWidth <= 1024); // Example: Consider width <= 1024 as tablet view
      setIsMobileView(window.innerWidth <= 480);
    };

    // Call checkScreenSize once to determine initial view
    checkScreenSize();

    // Add event listener to check screen size on resize
    window.addEventListener('resize', checkScreenSize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);
  useEffect(() => {
    // This function will be called whenever the route changes
    // You can update your value here based on the new route
    // For example:


    // Regular expression to match the pattern /developer/:appID/ followed by any string
    const regex = /^\/developer\/([^/]+)\/(.*)$/; // Matches /developer/:appID/ followed by any string
    const match = location.pathname.match(regex);


    if (match) {
      const appID = match[1];

      const afterAppID = match[2];
      localStorage.setItem("sidenav", "true");
      setAppIsSidenav(true);

    } else {
      localStorage.setItem("sidenav", "false");
      setAppIsSidenav(false);

    }

    // Perform actions based on the new route
  }, [location.pathname]);


  const gaTrakingID = process.env.REACT_APP_GA_ID;
  if (gaTrakingID) {
    // Initialize Google Analytics with the tracking ID
    ReactGA.initialize(gaTrakingID);
  } else {
    console.error("REACT_APP_GA_ID environment variable is not defined.");
  }
  // ReactGA.initialize("G-DQFSMSM9NE");
  return (
    <AppProvider i18n={enTranslations}>
   {location.pathname.includes("/developer") ? (
  <Provider store={developerStore}>
    {/* Render components specific to developer */}
    <div>
      {location.pathname === "/developer/login" ? (
        // Render only the login page without header and sidebar
        <Outlet />
      ) : location.pathname === "/developer/signup" ? (
        // Render only the signup page without header and sidebar
        <Outlet />
      ) : (
        // Render the usual layout with header and sidebar
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', position: 'relative', backgroundColor: "#f6f6f7" }}>
          {/* Header */}
          <div style={{ height: '55px', background: 'none', textAlign: 'center', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, backgroundColor: "#f6f6f7" }}>
            <DevHeader />
          </div>
          {/* Main Content */}
          {isMobileView || isTabletView ? (
            <div style={{ marginTop: '52px' }} className="container">
              <Outlet />
            </div>
          ) : (
            <div style={{ display: 'flex', flex: '1', flexDirection: 'row', marginTop: '52px', backgroundColor: "#f6f6f7" }}>
              {/* Sidebar */}
              <div style={{ minWidth: '241px', maxWidth: '241px', width: '100%', zIndex: 1, backgroundColor: "#f6f6f7" }}>
                <div className="container">
                  {isSidenav ? <AppsSidebar /> : <Sidebar />}
                </div>
              </div>
              {/* Main Content Area */}
              <div style={{ flex: '1', overflowY: 'auto', zIndex: 0, backgroundColor: "#f6f6f7" }}>
                <div className="container">
                  <Outlet />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  </Provider>
) : (
  <Provider store={store}>
    {/* Render components specific to non-developer */}
    <div>
      {!location.pathname.includes("/shiprocket_audience") && <AppStoreHeader />}
      <Outlet />
    </div>
  </Provider>
)}

    </AppProvider>
  );
};

const NotFoundRoute = () => {
  return (

    <Route
      path="*"
      element={
        <div className="flex justify-center items-center min-h-screen">
          <div>404 - Page not found</div>
        </div>
      }
    />
  );
};
const appRouter = createBrowserRouter([


  {
    path: "",
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <SellerDashboard />,
      },
      {
        path: "/:slug",
        element: <AppInfo />,
        children: [
          {
            path: "",
            element: <AppInfo />,
          },
        ],
      },
      {
        path: "/subscription",
        element: <Subscription />,
        children: [
          {
            path: "",
            element: <Subscription />,
          },
        ],
      },

      {
        path: "/developer",
        element: <DevHome />,
      },

      {
        path: "/developer/apps",
        element: <DevAppPage />,
      },
      {
        path: "/developer/createApps",
        element: <DevCreateApps />,
      },
      {
        path: "/developer/settings",
        element: <DevSettings />,
      },
      {
        path: "/developer/login",
        element: <DeveloperLogin />,
      },
      {
        path: "/developer/signup",
        element: <DeveloperSignup />,
      },
      {
        path: "/shiprocket_audience",
        element: <Shiprocket_Audience />,
      },
      {
        path: "/shiprocket_audience/product",
        element: <ProductPage/>,
      },
      {
        path: "/shiprocket_audience/dashboard",
        element: <AudienceDashboard/>,
      },
      {
        path: "/developer/:appID/appoverview",
        element: <AppOverView />,
        children: [
          {
            path: "",
            element: <AppOverView />,
          },
        ],
      },

      {
        path: "/developer/:appID/edit",
        element: <TechConfiguration />,
        children: [
          {
            path: "",
            element: <TechConfiguration />,
          },
        ],
      },
      {
        path: "/developer/:appID/edit/managelist",
        element: <ManageConfigurations />,
        children: [
          {
            path: "",
            element: <ManageConfigurations />,
          },
        ],
      },
      {
        path: "/developer/:appID/edit/plan",
        element: <DevPlan />,
        children: [
          {
            path: "",
            element: <DevPlan />,
          },
        ],
      },
      {
        path: "/developer/:appID/edit/permissions",
        element: <DevPermissionnew />,
        children: [

        ],
      },
      {
        path: "*",
        element: <Routes><Route path="*" element={<NotFoundPage />} /></Routes>,
      },
    ],
  },


]);

const rootStyle = {
  background: "rgb(249, 249, 252)", // Change this to the color you want
};
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <div style={rootStyle}>
    <RouterProvider
      fallbackElement={
        <div className="flex justify-center items-center min-h-screen">
          <Spinner size="large" />
        </div>
      }
      router={appRouter}
    />
  </div>
);
